import React, { Component } from 'react';

class Header extends Component {
  render() {

    if(this.props.data){
      // get info from JSON
      var name = this.props.data.name;
      var chname = this.props.data.chname;
      var occupation= this.props.data.occupation;
      var description= this.props.data.description;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url} target = "_blank"><i className={network.className}></i></a></li>
      })
    }

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         {/* top navigation tag */}
         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">  About & Contact </a></li>
            <li><a className="smoothscroll" href="#resume">  CV</a></li>
            <li><a className="smoothscroll" href='#research'>  Research</a></li>
            <li><a href="teaching.html">  Teaching </a></li>
            <li><a className="smoothscroll" href="#testimonials">  Life Philosophy</a></li>
         </ul>

      </nav>

      <div className="row banner">
         <div className="banner-img">
            <img className="profile-pic"  src={profilepic} alt="Chen-Chih Profile Pic" />
         </div>
         <div className="banner-text">
            <h1 className="responsive-headline">{name}</h1>
            {/* span tag: add a hook to a part of a text or a part of a document */}
            <h3> <div style={{"line-height":30}}>Hi! I am Chen-Chih. <br/>
            I am passionate about partial differential equations, nonlinear fluid dynamics, and data-driven/physics-informed methods for learning stochastic governing laws.<br/><br/>
            </div>
            </h3> 
            {/* <h3>Hi! I'm a {occupation} passionate about Partial Differential Equations and Fluid Mechanics.</h3> */}
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
